module.exports = __webpack_public_path__ + "static/media/2.93f655d8.png";